import { Children, cloneElement } from 'react';
import { useParams } from 'react-router-dom';

import { useApplicantGetQueryById } from '../../Common/Queries/applicantQueries';

export function ApplicantContainer({ children, ...props }) {
  const { id } = useParams();
  const applicantData = useApplicantGetQueryById(id);

  return Children.only(cloneElement(children, { applicantData, ...props }));
}
